<template>
    <div class="popup-services-error popup-all">
            <div class="popup-container">
                <div class="popup-vue">
                    <img class="popup-close" src="/img/credit-landing-vue/popup-close.svg" alt="Close" @click="popupClose()">
                    <div class="popup-title">{{ 'Сервіс тимчасово не працює' }}</div>
                </div>
            </div>
    </div>
</template>
 
<script>

  export default {
    name: 'popup-services-error',
    methods: {
        popupShow: function() {
            this.$el.style.display = 'block';
        },
        popupClose: function() { 
            this.$el.style.display = 'none';
        },
    }
  }

</script>